import { createContext } from "react";

export interface SessionRecordingContextValue {
  sessionRecordingInProgress: boolean;
  startSessionRecording(): void;
  stopSessionRecording(): void;
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const SessionRecordingContext = createContext<SessionRecordingContextValue>(undefined!);
